import React from "react";
import { Controller, useForm } from "react-hook-form";
// import { SMSSettings } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { RequirementSettings } from "../../../../core";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: any) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: { value: number };
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<RequirementSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderTolerance = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Tolerance</label>
          <Controller
            control={control}
            rules={{
              required: "Tolerance is required",
              max: { value: 100, message: "Tolerance must  be less than 100%" },
              min: { value: 0, message: "Tolerance must  be more than 0%" },
              valueAsNumber: true,
            }}
            name="value"
            defaultValue={props.data?.value || 0}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Tolerance"
                name={name}
                value={value}
                onChange={onChange}
                id="value"
              />
            )}
          />
          <ErrorMessage>{errors.value?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Requirement Settings</h4>
        <div className="row gutter-10">
          {renderTolerance()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
